"use client"

import { useState, useRef, useEffect } from "react"
import styles from "./Tooltip.module.css"

const Tooltip = ({ children, text, position = "top", delay = 500, disabled = false }) => {
  const [isVisible, setIsVisible] = useState(false)
  const [timeoutId, setTimeoutId] = useState(null)
  const tooltipRef = useRef(null)
  const triggerRef = useRef(null)

  const showTooltip = () => {
    if (disabled || !text) return

    const id = setTimeout(() => {
      setIsVisible(true)
    }, delay)
    setTimeoutId(id)
  }

  const hideTooltip = () => {
    if (timeoutId) {
      clearTimeout(timeoutId)
      setTimeoutId(null)
    }
    setIsVisible(false)
  }

  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [timeoutId])

  const tooltipClasses = [styles.tooltip, styles[position], isVisible && styles.visible].filter(Boolean).join(" ")

  return (
    <div
      className={styles.container}
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
      onFocus={showTooltip}
      onBlur={hideTooltip}
      ref={triggerRef}
    >
      {children}
      {text && (
        <div className={tooltipClasses} ref={tooltipRef} role="tooltip" aria-hidden={!isVisible}>
          <div className={styles.content}>{text}</div>
          <div className={styles.arrow}></div>
        </div>
      )}
    </div>
  )
}

export default Tooltip
